<template>
  <v-container>
    <v-alert
      v-if="checkCriticas() && editar"
      color="error"
      :value="true"
      class="mb-3 mt-0"
    >
      Instruções
      <ul>
        <li class="mb-1 mt-3">
          Os campos que contém inconsistências estão marcados em vermelho, com
          um texto detalhando a razão da reprovação.
        </li>
      </ul>
    </v-alert>
    <v-confirm-dialog ref="confirm" />
    <v-form ref="formResidencia" @submit.prevent="saveResidencia">
      <v-card class="elevation-1">
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>Residência Atual</v-toolbar-title>
          <v-spacer />
        </v-toolbar>

        <v-card-text>
          <v-form-creator :schema="schema" :root="form" />
        </v-card-text>

        <v-card-actions class="px-3 pb-3">
          <v-spacer />
          <v-btn
            :disabled="!editar"
            type="submit"
            large
            dark
            color="success"
            :block="$vuetify.breakpoint.smAndDown"
          >
            <v-icon class="mr-2">save</v-icon>Salvar
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>

      <v-loading :show="loading" message="Processando requisição" />
    </v-form>
  </v-container>
</template>

<style>
.v-messages__wrapper {
  color: #fd2727;
}
</style>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import FormModel from '@/models/form';
import VConfirmDialog from '@/components/confirmDialog';
import VFormCreator from '@/components/formCreator';
import VLoading from '@/components/loading';
import moedaFilter from '@/filters/moeda';
import api from '@/services/api';

export default {
  components: { VConfirmDialog, VFormCreator, VLoading },

  data() {
    return {
      form: new FormModel({
        id: null,
        endereco: {
          logradouro: null,
          numero: null,
          bairro: null,
          complemento: null,
          cep: null,
        },
        valorAluguel: null,
        __valorAluguel: null, // necessário para realizar a conversão do campo valorAluguel para float
        residenciaDocumento: null,
        residenciaTipoRisco: [],
        residenciaServico: [],
        pagaAluguel: null,
      }),
      data: {},
      reprovado: false,
      loading: false,
      triggerBuscaCEP: true,
      editar: null,
    };
  },

  computed: {
    schema() {
      let { required, cep, minlength, moeda } = this.$rules;

      return [
        {
          label: 'CEP',
          model: 'endereco.cep',
          cols: { sm6: true },
          disabled:
            !this.editar ||
            (this.verificada &&
              this.reprovado &&
              !this.data.endereco.criticaCep),
          hint:
            this.data.endereco && this.editar
              ? this.data.endereco.criticaCep
              : ' ',
          persistentHint: true,
          mask: '#####-###',
          rules: this.form.endereco.cep ? [required, cep(false)] : [],
          class: { 'mr-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Endereco',
          model: 'endereco.logradouro',
          cols: { sm6: true },
          disabled:
            !this.editar ||
            (this.hasCEP &&
              this.verificada &&
              this.reprovado &&
              !this.data.criticaNomeSocial),
          hint:
            this.data.endereco && this.editar
              ? this.data.endereco.criticaLogradouro
              : ' ',
          persistentHint: true,
          rules: this.hasCEP ? [] : [required, minlength(3)],
          class: { 'ml-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Número',
          model: 'endereco.numero',
          cols: { sm6: true },
          disabled:
            !this.editar ||
            (this.verificada &&
              this.reprovado &&
              !this.data.endereco.criticaNumero),
          hint:
            this.data.endereco && this.editar
              ? this.data.endereco.criticaNumero
              : ' ',
          persistentHint: true,
          rules: [required],
          class: { 'mr-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Bairro',
          model: 'endereco.bairro',
          cols: { sm6: true },
          disabled:
            !this.editar ||
            (this.hasCEP &&
              this.verificada &&
              this.reprovado &&
              !this.data.endereco.criticaBairro),
          hint:
            this.data.endereco && this.editar
              ? this.data.endereco.criticaBairro
              : ' ',
          persistentHint: true,
          rules: this.hasCEP ? [] : [required, minlength(3)],
          class: { 'ml-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Complemento',
          model: 'endereco.complemento',
          cols: { sm6: true },
          disabled:
            !this.editar ||
            (this.verificada &&
              this.reprovado &&
              !this.data.endereco.criticaComplemento),
          hint:
            this.data.endereco && this.editar
              ? this.data.endereco.criticaComplemento
              : ' ',
          persistentHint: true,
          class: { 'mr-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Município',
          value: 'Sorocaba',
          cols: { sm6: true },
          disabled: true,
          rules: [required],
          class: { 'ml-2 mt-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'UF',
          value: 'SP',
          cols: { sm6: true },
          disabled: true,
          rules: [required],
          class: { 'mr-2 mt-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Risco(s) da residência',
          model: 'residenciaTipoRisco',
          cols: { sm6: true },
          disabled:
            !this.editar ||
            (this.verificada &&
              this.reprovado &&
              !this.data.criticaInscricaoResidenciaTipoRisco),
          hint:
            this.data.criticaInscricaoResidenciaTipoRisco && this.editar
              ? this.data.criticaInscricaoResidenciaTipoRisco
              : ' ',
          persistentHint: true,
          rules: [required],
          items: this.$store.params.residenciaTipoRisco,
          multiple: true,
          listeners: {
            change: (values) => {
              let last = values[values.length - 1];
              let lastIsAreaRisco =
                last && last.id === window.Config.ID_SEM_RISCO;

              if (lastIsAreaRisco) {
                this.form.residenciaTipoRisco = values.filter(
                  (d) => d.id === window.Config.ID_SEM_RISCO
                );
              } else {
                this.form.residenciaTipoRisco = values.filter(
                  (d) => d.id !== window.Config.ID_SEM_RISCO
                );
              }
            },
          },
          class: { 'ml-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Serviço(s) da residência',
          model: 'residenciaServico',
          cols: { sm6: true },
          disabled:
            !this.editar ||
            (this.verificada &&
              this.reprovado &&
              !this.data.criticaInscricaoResidenciaServico),
          hint:
            this.data.criticaInscricaoResidenciaServico && this.editar
              ? this.data.criticaInscricaoResidenciaServico
              : ' ',
          persistentHint: true,
          items: this.$store.params.residenciaServico,
          multiple: true,
          class: { 'mr-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Documento da residência',
          model: 'residenciaDocumento',
          cols: { sm6: true },
          disabled:
            !this.editar ||
            (this.verificada &&
              this.reprovado &&
              !this.data.criticaIdResidenciaDocumento),
          hint:
            this.data.criticaIdResidenciaDocumento && this.editar
              ? this.data.criticaIdResidenciaDocumento
              : ' ',
          persistentHint: true,
          rules: [required],
          items: this.$store.params.residenciaDocumento,
          class: { 'ml-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Paga aluguel?',
          model: 'pagaAluguel',
          cols: { sm6: true },
          disabled:
            !this.editar ||
            (this.verificada &&
              this.reprovado &&
              !this.data.criticaValorAluguel),
          rules: [required],
          items: [
            { id: true, descricao: 'SIM' },
            { id: false, descricao: 'NÃO' },
          ],
          returnObject: false,
          class: { 'mr-2': this.$vuetify.breakpoint.smAndUp },
        },
        {
          label: 'Valor do aluguel',
          cols: { sm6: true },
          rules: this.form.pagaAluguel ? [required, moeda] : [],
          prefix: 'R$',
          type: 'tel',
          disabled:
            !this.form.pagaAluguel ||
            !this.editar ||
            (this.verificada &&
              this.reprovado &&
              !this.data.criticaValorAluguel),
          hint:
            this.data.criticaValorAluguel && this.editar
              ? this.data.criticaValorAluguel
              : ' ',
          persistentHint: true,
          value: moedaFilter(this.form.__valorAluguel),
          listeners: {
            change: (v) => {
              this.form.__valorAluguel = v;
              this.form.valorAluguel = v.replace('.', '').replace(',', '.');
            },
          },
          class: { 'ml-2 mt-2': this.$vuetify.breakpoint.smAndUp },
        },
      ];
    },

    hasCEP() {
      let cep = this.form.endereco.cep;

      if (cep && cep.length === 8) {
        return true;
      }

      return false;
    },
  },

  watch: {
    async 'form.endereco.cep'() {
      if (this.triggerBuscaCEP) {
        if (this.hasCEP) {
          this.form.endereco.logradouro = null;
          this.form.endereco.bairro = null;
          try {
            this.loading = true;

            let { data } = await api.fetchEndereco(this.form.endereco.cep);
            let endereco = data[0];

            if (
              endereco &&
              endereco.idLocalidade === window.Config.CODIGO_SOROCABA
            ) {
              this.form.endereco.logradouro = `${endereco.tipoLogradouro} ${endereco.logradouro}`;
              this.form.endereco.bairro = endereco.bairro;
              this.form.endereco.uf = endereco.ufSigla;
            } else {
              throw {
                data: {
                  message:
                    'Apenas endereços da cidade de Sorocaba são aceitos.',
                },
              };
            }
          } catch ({ data: { message } }) {
            if (message) {
              this.$store.$emit('show-message', {
                message,
                timeout: 5000,
                color: 'danger',
              });
            }
          } finally {
            this.loading = false;
          }
        }
      }
    },

    'form.areaRisco'(val) {
      if (!val) {
        this.form.residenciaTipoRisco = null;
      }
    },

    'form.pagaAluguel'(val) {
      if (!val) {
        this.form.__valorAluguel = null;
        this.form.valorAluguel = null;
      }
    },
  },

  async created() {
    try {
      this.loading = true;

      let { data } = await api.fetchResidencia();

      this.data = data;

      let editar = await api.fetchStatus();

      this.editar = editar.data.operacoes.editar;

      this.reprovado = editar.data.situacaoInscricao.descricao == 'Reprovada';
      this.verificada = editar.data.verificada;

      if (!this.editar) {
        document.getElementsByClassName('v-text-field__prefix')[0].style.color =
          '#ddd';
      }

      this.form.id = data.id; // sem id o save chama post em vez de put
      await this.form.populate(data);

      if (data.endereco) {
        this.triggerBuscaCEP = false; // para não disparar o watcher de busca de CEP

        setTimeout(() => {
          // necessário por causa do race condition
          this.triggerBuscaCEP = true;
        }, 0);

        if (
          this.form.residenciaTipoRisco &&
          this.form.residenciaTipoRisco.length > 0
        ) {
          this.form.areaRisco = true;
        } else {
          this.form.areaRisco = false;
        }

        if (this.form.valorAluguel) {
          this.form.__valorAluguel = this.form.valorAluguel
            .toString()
            .replace('.', ',');

          this.form.pagaAluguel = true;
        } else {
          this.form.pagaAluguel = false;
        }
      }
    } catch ({ data: { message } }) {
      if (message) {
        this.$store.$emit('show-message', {
          message,
          timeout: 5000,
          color: 'danger',
        });
      }
    } finally {
      this.loading = false;
    }
  },

  methods: {
    checkCriticas() {
      let keys = Object.keys(this.data);
      for (let i = 0; i < keys.length; i++) {
        if (keys[i].includes('critica')) {
          return true;
        }
      }
      return false;
    },
    async saveResidencia() {
      var renda = 0;
      for (var ix = 0; ix < this.form.pessoa.length; ix++) {
        if (this.form.pessoa[ix].rendaBruta) {
          renda = renda + this.form.pessoa[ix].rendaBruta;
        }
      }
      if (this.form.pagaAluguel && this.form.valorAluguel > renda) {
        this.$refs.confirm
          .open(
            'Valor de aluguel declarado é superior à soma das rendas.<br><br>Informação declarada está correta?'
          )
          .then((response) => {
            if (response) {
              this.saveAndMessage();
            }
          });
      } else {
        this.saveAndMessage();
      }
    },

    async saveAndMessage() {
      let url = '/inscricao/residencia';
      if (this.$refs.formResidencia.validate()) {
        try {
          this.loading = true;

          await this.form.save(url);

          this.$store.$emit('show-message', {
            message: `Residência ${
              this.form.id ? 'atualizada' : 'cadastrada'
            } com sucesso!`,
            color: 'success',
          });

          this.$router.push('/');
        } catch ({ data: { message } }) {
          if (message) {
            this.$store.$emit('show-message', {
              message,
              timeout: 5000,
              color: 'danger',
            });
          }
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>
